export default __webpack_public_path__ + "static/media/doctor_consultation_low.4e5ae5f7.svg";